// Delegation also covers recommendation and wishlist cards loaded after the page.
(() => {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-memorra-card-share]');
    if (!button) return;
    event.preventDefault();
    const data = { title: button.dataset.shareTitle, url: button.dataset.shareUrl };
    let status = document.querySelector('[data-memorra-card-status]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'visually-hidden';
      status.dataset.memorraCardStatus = '';
      status.setAttribute('role', 'status');
      document.body.appendChild(status);
    }
    try {
      if (navigator.share) await navigator.share(data);
      else { await navigator.clipboard.writeText(data.url); status.textContent = button.dataset.success; }
    } catch (error) {
      if (error.name === 'AbortError') return;
      try { await navigator.clipboard.writeText(data.url); status.textContent = button.dataset.success; }
      catch (_) { status.textContent = button.dataset.error; }
    }
  });
})();
